import type { RichTextToolT } from "./types";

export const LINK_TOKEN_ERROR = "Links can't include personalization fields.";

const LINK_SCHEME = /^(https?:|mailto:|tel:)/i;
const TOKEN_BRACES = /\{\{|\}\}/;
const FORMATTING = /<(strong|em|u|ul|ol|a)[\s>]/i;

const TOOL_FORMATS: Partial<Record<RichTextToolT, string>> = {
  bold: "bold",
  italic: "italic",
  underline: "underline",
  strike: "strike",
  bullet: "list",
  ordered: "list",
  link: "link",
};

export const formatsFor = (tools: RichTextToolT[]) => [
  ...new Set(tools.flatMap((tool) => (TOOL_FORMATS[tool] ? [TOOL_FORMATS[tool] as string] : []))),
];

export const isAllowedLinkHref = (href: string) => LINK_SCHEME.test(href);

export const normalizeLinkUrl = (url: string) => {
  const trimmed = url.trim();
  return LINK_SCHEME.test(trimmed) ? trimmed : `https://${trimmed}`;
};

export const linkUrlError = (url: string) => (TOKEN_BRACES.test(url) ? LINK_TOKEN_ERROR : null);

const escapeHtml = (value: string) => value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export const textToEditorHtml = (text: string) =>
  text
    .split("\n")
    .map((line) => `<p>${line ? escapeHtml(line) : "<br>"}</p>`)
    .join("")
    .replace(/^<p><br><\/p>$/, "");

export const hasFormatting = (html: string) => FORMATTING.test(html);
